import styled from 'styled-components';

export const PortableTextWrapper = styled.div``;

export const Description = styled.span`
  position: relative;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.gray};
  width: 100%;
  bottom: 0;
  left: 0;
  margin-bottom: 16px;
  display: block;
`;
